module.exports = __webpack_public_path__ + "img/11-estatus-vermas.1cc50986.svg";